import { OrderSummary } from '~/adapters/services/accounts/orders/types';
import { useAuth } from '~/contexts/Auth/AuthContext';
import { useLinks } from '~/contexts/LinkContext';
import { reorderLink } from '~/adapters/services/rfe/links';
import { useUserAccount } from '~/contexts/UserAccount/UserAccountContext';

const ALPHA_CHARACTERS = 'abcdefghjkmnpqrstuvwxyz'.split('');
const ALPHANUMERIC_CHARACTERS = [...'0123456789'.split(''), ...ALPHA_CHARACTERS];

const toAlpha = (value: number, type: 'alpha' | 'alphanumeric', minLength: number): string => {
    const characterSet = type === 'alpha' ? ALPHA_CHARACTERS : ALPHANUMERIC_CHARACTERS;
    const base = characterSet.length;
    let result = '';
    let num = value;
    while (num > 0) {
        const remainder = num % base;
        result = characterSet[remainder] + result;
        num = Math.floor(num / base);
    }
    if (result === '') {
        [result] = characterSet;
    }
    if (result.length < minLength) {
        result = result.padStart(minLength, characterSet[0]);
    }
    return result;
};

export const getDesignCId = (designId: number, accountId: number): string => {
    const accountAlphaId = toAlpha(accountId, 'alpha', 3);
    const designAlphaNumericId = toAlpha(designId, 'alphanumeric', 9);
    const lastThreeOfAccountId = accountAlphaId.slice(-3);
    const key = lastThreeOfAccountId + designAlphaNumericId;
    return `${key.slice(0, 4)}-${key.slice(4, 8)}-${key.slice(8, 12)}`;
};

export const useOrderLinks = (order: OrderSummary, reorderAddToCartEnabled = false) => {
    const { isImpersonatedExperience } = useAuth();
    const { rfeLink } = useLinks();
    const {
        account: { id: accountId },
    } = useUserAccount();

    const designUrl = isImpersonatedExperience
        ? `${rfeLink}/admin/designs/${order.designId}`
        : `${rfeLink}/designs/${order.designName}/${order.designId}-${order.account.id}/retrieve`;

    const reorderUrl = isImpersonatedExperience
        ? `${rfeLink}/admin/internal_checkouts/create_reorder_ap_order?design_id=${order.designId}&reorder=${order.id}`
        : reorderLink(order.id, reorderAddToCartEnabled);

    const trackOrderUrl = `${rfeLink}/track/${order.id}-${order.account.id}`;

    const invoiceUrl = `${rfeLink}/track/${order.id}-${order.account.id}/invoice`;

    const editDesignUrl = `${rfeLink}/lab?cid=${getDesignCId(order.designId, accountId)}`;

    const reportProblemUrl = `${rfeLink}/order_problem?order_id=${order.id}`;

    return {
        designUrl,
        reorderUrl,
        trackOrderUrl,
        invoiceUrl,
        editDesignUrl,
        reportProblemUrl,
    };
};
